import React from 'react'
import { FieldValues, useController } from 'react-hook-form'

import InputPhone from '../InputPhone/InputPhone'
import { IInputPhoneProps } from '../InputPhone/types'
import useStyles from './styles'
import { InputPhoneControlledProps } from './types'

export const InputPhoneControlled = <T extends FieldValues>(props: InputPhoneControlledProps<T>) => {
  const { control, name, changeHandler, handleBlur, title, ...rest } = props
  const classes = useStyles()

  const {
    field: { value, onChange, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control,
  })

  const onPhoneInputChange: IInputPhoneProps['onChange'] = (value, country) => {
    const result = { value, country }
    onChange(value)
    changeHandler?.(result)
  }

  const onPhoneInputBlur: IInputPhoneProps['onBlur'] = () => {
    onBlur()
    handleBlur?.()
  }

  return (
    <div>
      {title && <div className={classes.title}>{title}</div>}
      <InputPhone onChange={onPhoneInputChange} onBlur={onPhoneInputBlur} value={value} {...rest} />
      {error?.message && <div className={classes.errorMessage}>{error?.message}</div>}
    </div>
  )
}
